import SettingsPage from '@/components/Settings'
import { createFileRoute } from '@tanstack/react-router'
import { guardAuthenticated } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/settings')({
  component: RouteComponent,
  beforeLoad: guardAuthenticated,
})

function RouteComponent() {
  console.log('Settings page loaded')

  return <SettingsPage />
}
